<template lang="pug">
el-dialog(width="650px", top="35px", :title="title", :visible.sync="visible", :close-on-click-modal="false")
  .header
    el-radio-group(v-model="curTabId", size="mini")
      el-radio-button(v-for="{ id, label } in tabs", :key="id", :label="id") {{ label }}
    el-input(class="searchInput" v-model="filterText"  placeholder="输入关键字进行过滤" prefix-icon="el-icon-search" clearable size="small")
  keep-alive
    el-row(:key="curTabId")
      el-col(:span="12")
        el-tree(ref="tree", lazy, node-key="id", :load="load", v-slot="{ node, data: { id, label, leaf, icon } }", :props="props", :filter-node-method="filterNode")
          label.tree-item
            el-checkbox(v-if="leaf", v-model="ids", :label="id") #[span]
            i.icon(v-if="icon", :class="icon") &nbsp;
            | {{ label }}
      el-col(:span="12")
        user-list(:list="checked", :disabled="false", @delete="deleteUser")
  template(#footer)
    el-button(size="small", @click="close()") 取消
    el-button(size="small", type="primary", @click="submit()") 确定
</template>
<script>
import UserList from "@/CommonDP/components/userList/index.vue";
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import role from "@/CommonDP/service/admin/role-service";
import { gettouxAvatar } from "@/CommonDP/utils";
// 缓存人员数据
const _nodeCatch = {};
export default {
  components: { UserList },
  mixins: [asyncMixin],
  inheritAttrs: false,
  props: {
    title: { default: "选择", type: String },
    max: { default: Infinity, type: Number },
    getTabs: { default: undefined, type: Function }
  },
  data() {
    const tabMap = {};
    const baseTabs = [
      {
        id: "role-custom",
        label: "角色人员",
        root: [],
        get: this.role_user,
        data: []
      }
    ].map((item) => {
      tabMap[item.id] = item;
      return item;
    });

    const tabs = this.getTabs?.(baseTabs, tabMap) || baseTabs;
    const idList = tabs.map(({ data = [] }) =>
      data.map(({ id, raw }) => {
        _nodeCatch[id] = raw;
        return id;
      })
    );
    return {
      curTabId: tabs[0].id,
      tabs,
      idList,
      visible: !false,
      props: {
        isLeaf: "leaf"
      },
      filterText: ""
    };
  },
  computed: {
    ids: {
      get() {
        const { curIndex, idList } = this;
        return idList[curIndex];
      },
      set(val) {
        const { curIndex, idList, max } = this;
        const length = val?.length || 0;
        if (length > max) this.throwErr("选择数量不能超过数量:" + max);
        this.$set(idList, curIndex, val);
      }
    },
    curIndex() {
      const { curTabId, tabs } = this;
      return tabs.findIndex(({ id }) => id === curTabId);
    },
    curTab() {
      const { curIndex, tabs } = this;
      return tabs[curIndex];
    },
    checked() {
      return this.ids.map((id) => _nodeCatch[id]).filter((item) => item);
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getAvatar: gettouxAvatar,
    throwErr(text) {
      this.$message.error(text);
      throw new Error(text);
    },
    deleteUser(userId) {
      this.ids = this.ids.filter((id) => id !== userId);
    },
    async load(node, next) {
      const {
        curTab: { get }
      } = this;
      const isRoot = !node.level;
      const list = await get(node);
      for (const { raw, id } of list) {
        if (id) _nodeCatch[id] = raw;
      }
      next(list);
      await this.$nextTick();
      if (isRoot) {
        const {
          childNodes: [cnode]
        } = node;
        cnode?.loadData(() => {
          cnode.expanded = true;
        });
      }
    },
    async role_user({ key: roleId, label: roleName }) {
      const { enterpriseId } = this;
      const params = { roleId, enterpriseId, roleName };
      const { data } = await role.getSysRoleUserList(params);
      return data.map((raw) => ({ raw, leaf: true, id: raw.userId, label: raw.name, icon: "el-icon-user" }));
    },
    close() {
      this.visible = false;
      this.reject();
    },
    submit() {
      this.resolve(this.checked);
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped src="./select-user.scss"></style>
